import React from "react";
import "../../styles/StaticPages.css";
import { Link } from "react-router-dom";

const NotFound: React.FC = () => {
  return (
    <>
      <div className="static-hero">
        <div className="static-hero-inner">
          <h1>Error 404</h1>
        </div>
      </div>
      <div className="static-page-container">
        <div className="static-content">
          <h2>We are unable to locate your requested page.</h2>
          <p>
            The page you are attempting to reach is no longer available or may
            have been moved. To help us eliminate unavailable pages and improve
            the experience, please let us know if a link is broken.
          </p>
          <p>
            You may return to the <Link to="/">home page</Link> or contact our
            support team <a href="mailto:AIS.DE@cgi.com">support team</a>.
          </p>
        </div>
      </div>
    </>
  );
};

export default NotFound;
